module.exports = __webpack_public_path__ + "static/media/0403.8a169666.png";